webpackJsonp([39],{

/***/ 1564:
/***/ (function(module, exports) {

MOVE.VIDEOS = function (MOVE) {
    "use strict";

    var init = function init() {};
    MOVE.VIDEOS = {
        init: init
    };
    return MOVE.VIDEOS;
}(MOVE || {});

/***/ }),

/***/ 1682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_critical__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_videos_videos__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_videos_videos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_videos_videos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_app__);




/***/ }),

/***/ 19:
/***/ (function(module, exports) {

(function () {

    //bootstrap application
    MOVE.init();
})();

/***/ })

},[1682]);


// WEBPACK FOOTER //
// videos_critical-d4536437fb9f46a9f2e8.js